var _rect, _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.731,
    y: 81.953,
    width: 47,
    height: 12,
    rx: 2,
    transform: "rotate(45 89.731 81.953)",
    fill: "#CDD9E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E2",
    d: "m82.66 80.539 4.243 4.242-2.829 2.829-4.242-4.243z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.205,
    cy: 57.205,
    r: 35.125,
    transform: "rotate(45 57.205 57.205)",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.205,
    cy: 57.205,
    r: 27.202,
    transform: "rotate(45 57.205 57.205)",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.247 45.527a22.338 22.338 0 0 0-19.352-10.658",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/search_grey.edcad5334cfedac861f434314d14237e.svg";
export { ForwardRef as ReactComponent };